import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/store';
import { Action } from 'redux';
import ApiErrorResponse from '../models/ApiErrorResponse';
import { SidebarDisplayTypes } from 'src/enums/sidebar.display.types';

export const START_FETCHING = 'START_FETCHING';
export const STOP_FETCHING = 'STOP_FETCHING';
export const SET_ERROR = 'SET_ERROR';
export const TOGGLE_ERROR_MODAL = 'TOGGLE_ERROR_MODAL';
export const TOGGLE_SUCCESS_MODAL = 'TOGGLE_SUCCESS_MODAL';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export const MODE = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    VIEW: 'VIEW',
};

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export type IErrorResponse = ApiErrorResponse;

export interface IDispatchProps<T> {
    actions: T;
}

export interface ISystemState {
    isFetching: boolean;
    loggedIn: boolean;
    userName: string | null;
    isErrorModalVisible: boolean;
    isSuccessModalVisible: boolean;
    systemModalContent: {
        title: string | undefined;
        content: string | undefined;
    };
    sidebar: string | undefined;
}

interface StartFetchingAction {
    type: typeof START_FETCHING;
}

interface StopFetchingAction {
    type: typeof STOP_FETCHING;
}

interface ToggleErrorModalAction {
    type: typeof TOGGLE_ERROR_MODAL;
    payload: { title?: string; content?: string };
}

interface ToggleSuccesModalAction {
    type: typeof TOGGLE_SUCCESS_MODAL;
    payload: { title?: string; content?: string };
}

interface ToggleSidebar {
    type: typeof TOGGLE_SIDEBAR;
    payload: {
        sidebar: SidebarDisplayTypes.SIDEBAR_DISPLAY_BLOCK | SidebarDisplayTypes.SIDEBAR_DISPLAY_NONE | undefined;
    };
}

export type SystemActionTypes =
    | StartFetchingAction
    | StopFetchingAction
    | ToggleErrorModalAction
    | ToggleSuccesModalAction
    | ToggleSidebar;
